export {
  cn,
  getCurrentViewportSize,
  ViewportSizeAlias,
  ViewportSizes,
  type ViewportSize
} from '@group-gti/inferno-design-system-react';

function isObject(item: any) {
  return item && typeof item === 'object' && !Array.isArray(item);
}

export const deepExtend = (target: any, ...sources: any[]): any => {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        deepExtend(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }
  return deepExtend(target, ...sources);
};

// Creates an object nested within another object without requiring multi-line blank inits
export const createNestedObject = (base: Record<string, any>, names: string[]) => {
  for (let i = 0; i < names.length; i++) {
    base = base[names[i]] = base[names[i]] || {};
  }
};

export const convertBooleanToString = (value: boolean | undefined) => {
  if (value === true || value === false) {
    return value.toString();
  }
  return value;
};

export const convertStringToBoolean = (value: string | undefined) => {
  if (value === 'true' || value === 'false') {
    return value === 'true';
  }
  return value;
};

export const waitFor = (milliseconds: number): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, milliseconds));

export const bytesToSize = (bytes: number, fixed = 0) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)) as any, 10);
  if (i === 0) return `${bytes} ${sizes[i]}`;
  return `${(bytes / 1024 ** i).toFixed(fixed)} ${sizes[i]}`;
};
